// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__19lbX","tab":"Tabs_tab__2pI4d","tabActive":"Tabs_tabActive__7Cc2j"};